// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box {
  display: flex;
  width: 100%;
  height: 100vh;
  border: none;
  position: fixed;
  transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;
  font-size: 66px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 999;
  background: white;
}
.IMG {
  width: 250px;
}
/* 
button {
  display: inline-block;
  background: transparent;
  border: 2px solid currentcolor;
  color: white;
  padding: 0.5em 1em;
  border-radius: 5px;
  font-size: calc(16px + 2vw);
} */

[class*="loader-"] {
  display: inline-block;
  width: 1em;
  height: 1em;
  color: inherit;
  vertical-align: middle;
  pointer-events: none;
}
.loader-37 {
  border-right: 0.1em solid currentcolor;
  border-radius: 100%;
  color: #e800ff;
  animation: loader-37 800ms linear infinite;
  bottom: 0;
}
.loader-37:before,
.loader-37:after {
  content: "";
  width: 0.8em;
  height: 0.8em;
  display: block;
  position: absolute;
  top: calc(50% - 0.4em);
  left: calc(50% - 0.4em);
  border-left: 0.08em solid currentcolor;
  border-radius: 100%;
  animation: loader-37 400ms linear infinite reverse;
}
.loader-37:after {
  width: 0.6em;
  height: 0.6em;
  top: calc(50% - 0.3em);
  left: calc(50% - 0.3em);
  border: 0;
  border-right: 0.05em solid currentcolor;
  animation: none;
}

@keyframes loader-37 {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/fullViewLoader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iEAAiE;EACjE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;;;;;;;;GASG;;AAEH;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,SAAS;AACX;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,kDAAkD;AACpD;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".box {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  border: none;\n  position: fixed;\n  transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;\n  font-size: 66px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 999;\n  background: white;\n}\n.IMG {\n  width: 250px;\n}\n/* \nbutton {\n  display: inline-block;\n  background: transparent;\n  border: 2px solid currentcolor;\n  color: white;\n  padding: 0.5em 1em;\n  border-radius: 5px;\n  font-size: calc(16px + 2vw);\n} */\n\n[class*=\"loader-\"] {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  color: inherit;\n  vertical-align: middle;\n  pointer-events: none;\n}\n.loader-37 {\n  border-right: 0.1em solid currentcolor;\n  border-radius: 100%;\n  color: #e800ff;\n  animation: loader-37 800ms linear infinite;\n  bottom: 0;\n}\n.loader-37:before,\n.loader-37:after {\n  content: \"\";\n  width: 0.8em;\n  height: 0.8em;\n  display: block;\n  position: absolute;\n  top: calc(50% - 0.4em);\n  left: calc(50% - 0.4em);\n  border-left: 0.08em solid currentcolor;\n  border-radius: 100%;\n  animation: loader-37 400ms linear infinite reverse;\n}\n.loader-37:after {\n  width: 0.6em;\n  height: 0.6em;\n  top: calc(50% - 0.3em);\n  left: calc(50% - 0.3em);\n  border: 0;\n  border-right: 0.05em solid currentcolor;\n  animation: none;\n}\n\n@keyframes loader-37 {\n  from {\n    transform: rotate(360deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
